import cx from 'classnames';
import TagId from '~/constants/common/TagId';
import { appAssetsCdnUrl } from '~/constants/environment';
import useIsInShaqHomeTakeoverExperiment from '~/hooks/common/experiments/useIsInShaqHomeTakeoverExperiment';
import useGetConsumerHref from '~/hooks/common/selectors/useGetConsumerHref';
import PriceTagIllustration from '~/icons/PriceTagIllustration';
import { nativeSrpPayload } from '~/native/common/utils';
import generateSearchLinkFilter from '~/utilities/generateSearchFilterLink';
import optimizeImage from '~/utilities/optimizeImage';
import styles from './Cards.module.css';
import {
  CardContainer,
  CardCta,
  CardSubtitle,
  CardTitle,
  CardTitleContainer
} from './Cards.styles';

const GREAT_DEALS_SEARCH_LINK = generateSearchLinkFilter({
  filters: { tagIds: [TagId.GreatDeal.toString()] }
});

export default function GreatDealsCard() {
  const getHref = useGetConsumerHref();
  const isInShaqExperiment = useIsInShaqHomeTakeoverExperiment();
  const backgroundImageUrl = optimizeImage(
    `${appAssetsCdnUrl}/images/home/${
      isInShaqExperiment ? 'budget-shaq.png' : 'budget-great-deals.png'
    }`,
    { format: 'auto', height: 600, quality: 90 }
  );

  return (
    <CardContainer
      className={cx(
        'relative bg-background-muted-subtle bg-contain bg-no-repeat',
        isInShaqExperiment ? 'bg-bottom' : 'bg-[center_bottom_74px]'
      )}
      data-analytics-id="Shop Great Deals"
      data-testid="great-deals-card"
      data-native-payload={nativeSrpPayload}
      href={getHref(GREAT_DEALS_SEARCH_LINK)}
      style={{
        backgroundImage: `url(${backgroundImageUrl})`
      }}
    >
      <CardTitleContainer>
        <CardTitle>Discover Great Deals!</CardTitle>
        <CardSubtitle>
          Cars priced $1,500 or more below the Kelley Blue Book® Typical
          Listing Price.
        </CardSubtitle>
      </CardTitleContainer>
      {isInShaqExperiment ? (
        <img
          alt=""
          className={cx(
            'pointer-events-none absolute inset-0 h-full w-full object-contain object-bottom',
            styles.keysOverlay
          )}
          data-testid="shaq-keys-overlay"
          loading="lazy"
          src={optimizeImage(
            `${appAssetsCdnUrl}/images/home/budget-shaq-keys.png`,
            { format: 'auto', height: 600, quality: 90 }
          )}
        />
      ) : (
        <PriceTagIllustration
          aria-hidden="true"
          className={cx('absolute left-[190px] top-[146px]', styles.priceTag)}
        />
      )}
      <CardCta data-testid="find-your-deal">Find Your Deal</CardCta>
    </CardContainer>
  );
}
